

export const CONSTANT_APIS={
  CREATE_STORE: 'stores/accept-invitation/id',
  PROVIDER_ACCEPT_INVITATION: 'providers/accept-invitation/:id',
  PROVIDER_FORGET_PASSWORD: 'providers/forget-password',
  PROVIDER_RESET_PASSWORD: 'providers/reset-password/code/:id',
  CATEGORIES_LIST:'public/store/categories',
  COUNTRIES_LIST:'api/country/get-all',
  VALIDATE_STORE:'public/store/validate-name',
  DASHBOARD_DATA: 'web/dashboard',
  TRANSACTIONS_LIST: 'web/dashboard/store/transactions',
  TRANSACTIONS_STATS: 'web/dashboard/store/transactions/total-stats',
  TRANSACTIONS_CSV: 'web/dashboard/store/transactions/csv',
  STORE_BRANCHES: 'web/redemption-points',
  FEATURES: 'features',
  BILLER_LIST: 'web/dashboard/store/biller',
  BILLER_STATS: 'web/dashboard/store/biller/total-stats',
  BILLER_IMPORT: 'web/dashboard/store/biller/import',
  BILLER_ENTRY: (entryId: number) => `web/dashboard/store/biller/${entryId}`,
  TAXI_AUTH_LOGIN: 'auth/taxi/login',
  PORTAL_LOGIN: 'auth/v1/lytchee-work-station/portal/login',
  PORTAL_FORGET_PASSWORD: 'auth/v1/lytchee-work-station/portal/forget-password',
  PORTAL_RESET_PASSWORD: 'auth/v1/lytchee-work-station/portal/reset-password',
  TAXI_DASHBOARD_SUMMARY: 'taxi/dashboard/summary',
  TAXI_DRIVERS: 'taxi/drivers',
  TAXI_DRIVER: (driverId: number) => `taxi/drivers/${driverId}`,
  TAXI_DRIVER_DEACTIVATE: (driverId: number) => `taxi/drivers/${driverId}/deactivate`,
  TAXI_DRIVER_REACTIVATE: (driverId: number) => `taxi/drivers/${driverId}/reactivate`,
  TAXI_WALLET: 'taxi/wallet',
  TAXI_WALLET_SETTLEMENTS: 'taxi/wallet/settlements',
  TAXI_SETTLEMENTS: 'taxi/settlements',
};
